/**
 * Подготовка XML к импорту (нормализация атрибутов и тегов для moddle).
 */
export function prepareForImport(xml) {
	if (!xml) return xml;

	const parser = new DOMParser();
	const xmlDoc = parser.parseFromString(xml, 'application/xml');
	const rootElement = xmlDoc.documentElement;
	const namespaceURI = rootElement ? rootElement.namespaceURI : null;

	const allElements = xmlDoc.getElementsByTagName('*');
	const replaceAttributeMap = new Map([
		['identifier', 'id'],
		['xsi:type', 'type'],
	]);
	const ignoreNodes = ['name', 'documentation'];

	for (let i = allElements.length - 1; i >= 0; i--) {
		const el = allElements[i];

		replaceAttributeMap.entries().forEach(([key, value]) => {
			if (el.hasAttribute(key)) {
				el.setAttribute(value, el.getAttribute(key));
				el.removeAttribute(key);
			}
		});

		if (el.localName === 'element') {
			const baseElement = xmlDoc.createElementNS(namespaceURI, 'baseElement');
			for (let attr of el.attributes) {
				let value = attr.value;
				if (attr.name === 'type' && value === 'Node') value = 'TechnologyNode';
				baseElement.setAttribute(attr.name, value);
			}
			while (el.firstChild) {
				baseElement.appendChild(el.firstChild);
			}
			el.parentNode.replaceChild(baseElement, el);
		} else if (el.localName === 'bendpoint') {
			const waypoint = xmlDoc.createElementNS(namespaceURI, 'waypoint');
			for (let attr of el.attributes) {
				waypoint.setAttribute(attr.name, attr.value);
			}
			while (el.firstChild) {
				waypoint.appendChild(el.firstChild);
			}

			let waypoints = Array.from(el.parentNode.children).find(
				item => item.localName === 'waypoints'
			);
			if (!waypoints) {
				waypoints = xmlDoc.createElementNS(namespaceURI, 'waypoints');
				el.parentNode.appendChild(waypoints);
			}

			waypoints.prepend(waypoint);
			el.parentNode.removeChild(el);
		} else if (!ignoreNodes.includes(el.localName) && el !== rootElement) {
			const newEl = xmlDoc.createElementNS(namespaceURI, `${el.localName}`);
			for (let attr of el.attributes) {
				newEl.setAttribute(attr.name, attr.value);
			}
			while (el.firstChild) {
				newEl.appendChild(el.firstChild);
			}
			el.parentNode.replaceChild(newEl, el);
		}
	}

	return new XMLSerializer().serializeToString(xmlDoc);
}
